/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_High_DetailInputs */



/**
* | output |
* | --- |
* | "0.25s (High Detail)" |
*
* @param {Ocr_Sampling_High_DetailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_high_detail = /** @type {((inputs?: Ocr_Sampling_High_DetailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_High_DetailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("0,25 s (Haute résolution)")
	if (locale === "de") return /** @type {LocalizedString} */ ("0,25 s (Hohe Detailgenauigkeit)")
	if (locale === "it") return /** @type {LocalizedString} */ ("0,25 s (Dettaglio elevato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("0,25 с (высокая детализация)")
	if (locale === "es") return /** @type {LocalizedString} */ ("0,25 s (Alto nivel de detalle)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("0.25秒（高细节）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0.25秒（高精細）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("0.25 सेकंड (उच्च विवरण)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("0,25s (Alto Detalhe)")
	return /** @type {LocalizedString} */ ("0.25s (High Detail)")
});